export const notificationMixin = {
  methods: {
    notiSuccessDefault(message, duration = 3000) {
      this.$toast.open({
        message: message,
        type: 'success',
        pauseOnHover: true,
        duration
      });
    },

    notiErrorDefault(message, duration = 3000) {
      this.$toast.open({
        message: message,
        type: 'error',
        pauseOnHover: true,
        duration
      });
    },

    /**
     * Call this function to show notification
     *
     * @param {String} title
     * @param {String} type ex. "created", "updated", "deleted"
     */
    notiSuccess(title, type) {
      this.$toast.open({
        message: `The ${title} was ${type}`,
        type: 'success',
        pauseOnHover: true
      });
    },

    notiWarning(
      message = 'Something went wrong on our system. Please try again in a moment or contact us.'
    ) {
      this.$toast.open({
        message,
        type: 'warning',
        pauseOnHover: true
      });
    },

    notiError(
      message = 'Something went wrong on our system. Please try again in a moment or contact us.'
    ) {
      this.$toast.open({
        message,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiSectionOverlap() {
      this.$toast.open({
        // message: `The entered section must not overlap other sections in this learning unit.`,
        message: `The specified section date-time overlaps your other sections.`,
        type: 'error',
        pauseOnHover: true,
        duration: 5000
      });
    },

    notiMeetingOverlap() {
      this.$toast.open({
        // message: `The entered section must not overlap other sections in this learning unit.`,
        message: `The specified meeting timing overlaps your other meetings.`,
        type: 'error',
        pauseOnHover: true,
        duration: 5000
      });
    },

    notiMeetingTooClose() {
      this.$toast.open({
        message: 'The specified meeting timing creates too short gaps with your other meetings.',
        type: 'warning',
        pauseOnHover: true,
        duration: 5000
      });
    },

    notiNotSufficientMeeting(number_of_online_meeting) {
      this.$toast.open({
        // message: `The entered section must not overlap other sections in this learning unit.`,
        message: `This LU requires ${number_of_online_meeting} online meetings but the specified timing is not sufficient to cover all meetings.`,
        type: 'error',
        pauseOnHover: true,
        duration: 5000
      });
    },

    notiWarningPrioritizeDatetime({ first = '', second = '' }) {
      this.$toast.open({
        message: `<strong>The ${first} date-time</strong> must be earlier than <strong>the ${second} date-time </strong>`,
        type: 'error',
        pauseOnHover: true,
        duration: 5000
      });
    },

    notiWarningDurationGreaterThanSixWeeks() {
      this.$toast.open({
        message:
          'The duration between the start and the end date-time must <strong>not longer</strong> than 6 weeks (42 days)',
        type: 'error',
        pauseOnHover: true
      });
    },

    notiWarningNotEqualDate(first, second) {
      this.$toast.open({
        message: `The ${first} date must not same as ${second} date`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiIncorrectFileType() {
      this.$toast.open({
        message: `Video file type must be in video, mp4, mov, avi`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiIncorrectImageType(types = '.jpeg, .jpg, .png') {
      this.$toast.open({
        message: `Accepted file type must be in ${types}`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiIncorrectFileSize(maxFilesize = 512) {
      this.$toast.open({
        message: `File is too big. Accepted file size up to ${maxFilesize} MB`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiInvalidFile() {
      this.$toast.open({
        message: `File is invalid.`,
        type: 'error',
        pauseOnHover: true
      });
    },
    // notiWarningNotEqualDate(first, second) {
    //   this.$toast.open({
    //     message: `<strong>"${first} date"</strong> must not same as <strong>"${second} date"</strong>`,
    //     type: "error",
    //     pauseOnHover: true,
    //   });
    // },

    notiSpotRemainingIsFull() {
      this.$toast.open({
        message: `This session is full`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiIsRequired(text) {
      this.$toast.open({
        message: `${text} is required`,
        type: 'error',
        pauseOnHover: true
      });
    },

    notiRequiredLearningOutcome(type) {
      this.$toast.open({
        message: `The learning outcome is required to publish this learning unit of type ${type}.`,
        type: 'error',
        duration: 5000
      });
    },

    notiRequiredAssessment() {
      this.$toast.open({
        message: `At least 1 assessments to measure the learning outcome are required to publish this learning unit of type OBEM.`,
        type: 'error',
        duration: 5000
      });
    },

    notiRequiredPost() {
      this.$toast.open({
        message: `At least 1 post is required to publish this learning unit of type General.`,
        type: 'error',
        duration: 5000
      });
    },

    notiRequiredAdditionalCriterion() {
      this.$toast.open({
        message: `At least 1 additional criterion is required if not evaluated by learning outcome.`,
        type: 'error',
        duration: 5000
      });
    }
  }
};
